const shared = {
  border: "border-line",
  text: "text-content",
  textSecondary: "text-content-secondary",
  cardBg: "bg-card",
  cardBorder: "border-line",
  buttonHover: "hover:bg-subtle",
  buttonText: "text-content-secondary",
  buttonTextHover: "hover:text-content",
  buttonBg: "bg-primary-500",
  buttonBgText: "text-on-primary",
  buttonHover2: "hover:bg-primary-400",
  input: "bg-app",
  inputBg: "bg-app",
  inputBorder: "border-line",
  inputText: "text-content",
  inputPlaceholder: "placeholder-content-faint",
  sidebarBg: "bg-surface",
};

export function panelThemeClasses() {
  return { ...shared, bg: "bg-surface" };
}

export function pageThemeClasses() {
  return { ...shared, bg: "bg-app" };
}

export type ThemeClassesFull = ReturnType<typeof panelThemeClasses>;
